// Contracts API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { contractsEndpoints } from './contracts.queries';

export const contractsApi = baseApi.injectEndpoints({ endpoints: contractsEndpoints });

export const {
  useGetContractsQuery,
  useGetContractFilterOptionsQuery,
  useGetContractFormQuery,
  useGetContractDetailQuery,
  useGetContractForReceiveShipmentQuery,
  useReceiveShipmentForContractMutation,
  useGetContractDiscrepancyQuery,
  useGetLinkedShipmentsQuery,
  useCreateContractMutation,
  useUpdateContractMutation,
  useDeleteContractMutation,
  useUpdateContractStatusMutation,
  useUnlinkContractShipmentMutation,
} = contractsApi;
